import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { QueryTypeContent, QueryActions, QueryDataSource } from './components';
import { QUERY_BUILDER_TYPES } from '../../constants';

interface QueryToolbarProps {
  target: any;
  conversation: any;
  queryBuilderType: typeof QUERY_BUILDER_TYPES[keyof typeof QUERY_BUILDER_TYPES];
  isQueryLoading: boolean;
  isQueryPreviewVisible: boolean;
  isStanleyQueryPanelVisible: boolean;
  isStanleyHistoryView: boolean;
  onStanleyQueryPanelToggle: () => void;
  onOpenStanleyHistory: () => void;
  onPreviewQueryRequest: () => void;
  onClearQueryRequest: () => void;
}

export const QueryToolbar: FC<QueryToolbarProps> = ({
  target,
  conversation,
  queryBuilderType,
  isQueryLoading,
  isQueryPreviewVisible,
  isStanleyQueryPanelVisible,
  isStanleyHistoryView,
  onStanleyQueryPanelToggle,
  onOpenStanleyHistory,
  onPreviewQueryRequest,
  onClearQueryRequest,
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <QueryTypeContent
          target={target}
          conversation={conversation}
          queryBuilderType={queryBuilderType}
        />
        <QueryDataSource />
      </div>
      <QueryActions
        target={target}
        isQueryLoading={isQueryLoading}
        isQueryPreviewVisible={isQueryPreviewVisible}
        isStanleyQueryPanelVisible={isStanleyQueryPanelVisible}
        isStanleyHistoryView={isStanleyHistoryView}
        onStanleyQueryPanelToggle={onStanleyQueryPanelToggle}
        onOpenStanleyHistory={onOpenStanleyHistory}
        onPreviewQueryRequest={onPreviewQueryRequest}
        onClearQueryRequest={onClearQueryRequest}
      />
    </div>
  );
};
